<script lang="ts">
	import type { Device } from 'src/types/Device';
	import { user_data } from 'src/stores';
	import VideoContainer from '../../CameraPlayer/VideoContainer.svelte';
	import WebRTCPlayer from '../../CameraPlayer/WebRTCPlayer.svelte';

	export let device: Device;

	// A Support Access session may not open a stream. This preview keeps the
	// container's empty background rather than a blocking state — the drawer's
	// player already says why there is no picture.
	$: canPlayStream = $user_data?.temporary !== true;
</script>

<div class="mb-s">
	<VideoContainer isZoomable={false}>
		{#if canPlayStream}
			<WebRTCPlayer deviceId={device.id} showControls={false} previewSize="medium" />
		{/if}
	</VideoContainer>
</div>
